<template
  ><!-- 智能活动海报 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img class="pointer" @click="clickLocalStep()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">智能活动海报</span>
    </div>
    <!--  活动条件表单部分 -->
    <div v-loading="fromLoading" class="secondstep">
      <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="153px">
        <div class="newsInfo">基本信息</div>
        <el-form-item label="计划名称:" required>
          <!-- prop="activityName" 活动名称 -->
          <el-input v-model="ruleForm.activityName" maxlength="15" show-word-limit placeholder="请填入活动名称" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="计划时间:" required>
          <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
          <div class="my_select_time">
            <el-date-picker
              v-model="activityTimeValue"
              type="datetimerange"
              class="rangeTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              ref="timeBox"
              @change="activityTimeChange"
              style="width: 400px; font-size: 12px"
              :picker-options="pickerOptionsValue"
              :default-time="defaultTime"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
          </div>
          <span class="lastTime" style="color: #666">
            活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天 <span style="color: #7B61FF">{{ timeOut }}</span> 小时
            <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </span>
        </el-form-item>
        <div class="newsInfo">海报设置</div>
        <el-form-item label="关联活动:" required>
          <div>
            <div class="actBox pointer" @click="handleAddTab()">添加活动（{{ tabList.length }}/5）</div>
            <span style="color:#999999;margin-left:5px">注意：该活动顺序为c 端轮播图顺序，请提前准备好活动及需要的排序</span>
          </div>
          <el-tabs v-model="activeName" type="card" closable @tab-remove="removeTab" @tab-click="handleClickTabs" class="new-tabs-header zindexBox">
            <el-tab-pane v-for="(item, i) in tabList" :label="`${item.name}${i + 1}`" :name="item.id" :key="item.id"> </el-tab-pane>
          </el-tabs>
          <div style="margin-left:-70px">
            <el-form-item label="活动链接:" required>
              <el-radio v-model="activityList[tabIndex].activityType" @change="changeRadio" :label="1">软件内活动</el-radio>
              <el-radio v-model="activityList[tabIndex].activityType" @change="changeRadio" :label="2">自定义</el-radio>
              <div v-show="activityList[tabIndex].activityType == 1">
                <el-input
                  @change="hangdleActivityEdit"
                  class="new_group_append"
                  placeholder="请输入内容"
                  style="width: 400px"
                  v-model="activityList[tabIndex].activityUrl"
                  :disabled="false"
                >
                  <template slot="append">
                    <span class="pointer" @click="hanleAction">选择</span>
                  </template>
                </el-input>
              </div>
              <div v-show="activityList[tabIndex].activityType == 2">
                <el-input placeholder="请输入内容" style="width: 400px" v-model="activityList[tabIndex].activityUrl"> </el-input>
              </div>
              <div class="card-point">
                <div class="card-rule">说明：</div>
                <div class="card-connet">
                  <p>1、软件内活动可直接选择活动也可在相应活动管理页将活动链接复制粘贴至此处；</p>
                  <p>2、自定义链接必须为京东域内链接，并且建议活动时间与自定义活动时间保持一致，避免用户参与活动失败。</p>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="活动名称:" required>
              <el-input v-model="activityList[tabIndex].name" maxlength="15" show-word-limit placeholder="请填入" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item label="活动简介:" required>
              <el-input v-model="activityList[tabIndex].brief" maxlength="20" show-word-limit placeholder="请填入" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  v-model="activityList[tabIndex].time"
                  type="datetimerange"
                  class="rangeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  ref="timeBox"
                  @change="activityTimeChange1"
                  style="width: 400px; font-size: 12px"
                  :picker-options="pickerOptionsValue1"
                  :disabled="activityList[tabIndex].activityType==1"
                >
                </el-date-picker>
                <i v-show="!activityList[tabIndex].timeDisable" class="el-icon-circle-close date_icon1" @click="activityList[tabIndex].time = []"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #7B61FF">{{ activityList[tabIndex].timeDay1 }}</span> 天
                <span style="color: #7B61FF">{{ activityList[tabIndex].timeOut1 }}</span> 小时
              </span>
            </el-form-item>
            <el-form-item label="活动图片:" required>
              <div>
                <el-button slot="reference" type="text" @click="handleImg()" style="width:95px;background: #7B61FF;color:#fff;margin-top: 5px;"
                  >选择图片</el-button
                >
              </div>
              <div class="smart">
                <div class="smart_left">
                  <img :src="activityList[tabIndex].picUrl" alt="" srcset="" />
                </div>
                <div class="smart_right">
                  <div class="smart_right_img">
                    <div class="smart_content">
                      <img :src="activityList[tabIndex].picUrl" alt="" srcset="" />
                      <div class="smart_content_title">{{ activityList[tabIndex].name }}</div>
                      <div class="smart_content_js">{{ activityList[tabIndex].brief }}</div>
                    </div>
                  </div>
                  <div class="smart_right_tip">图为预览效果，以实际投放位置效果为准</div>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="展示活动参与人数:" required>
          <el-radio v-model="ruleForm.isShowJoinNum" :label="1">是</el-radio>
          <el-radio v-model="ruleForm.isShowJoinNum" :label="0">否</el-radio>
          <div class="card-point">
            <div class="card-rule">说明：</div>
            <div class="card-connet">
              <p>
                选择“是”则表示在C端展示活动的参与人数，软件内活动为活动的实际参与人数，自定义活动为海报点击人数
              </p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="活动结束不展示海报:" required>
          <el-radio v-model="ruleForm.isShowPost" :label="1">是</el-radio>
          <el-radio v-model="ruleForm.isShowPost" :label="0">否</el-radio>
          <div class="card-point">
            <div class="card-rule">说明：</div>
            <div class="card-connet">
              <p>
                选择“是”则表示活动结束则相关联的海报在C端不展示
              </p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label-width="10px" style="margin: 0 0 20px 0; text-align: left">
          <el-button class="returnBtn" size="medium" @click="clickLocalStep()"> {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button>
          <template v-if="!backgroundOpacity">
            <!-- <el-button class="keepBtn" type="primary" size="medium" @click="joinBlackList = true" v-preventReClick>保存并完成设置</el-button> -->
            <el-popover
              placement="top-start"
              width="300"
              trigger="hover"
              content="因官方改造，小部件功能下架，如需实现类似功能可联系客服了解店铺装修定制业务~">
                <el-button class="keepBtn" type="primary" slot="reference">保存并完成设置</el-button>
            </el-popover>
          </template>
        </el-form-item>
        <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
      </el-form>
    </div>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 确定礼包模板弹窗 -->
    <gift-popup :activityDataID="25" @handleChoice="handleChoice" v-if="giftPopup" />

    <activityList v-if="activityPopup" @handleClose="handleClose" />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import giftPopup from "./giftPopup.vue";
import activityList from "./activityList.vue";
import selectProduct from "../select_product";
import { mapState, mapMutations } from "vuex";
import { saveSmartPost, editSmartPost, getActivityInfoFromUrl } from "@/api/paradiseAndTaskCommonController.js";
export default {
  components: {
    selectProduct,
    giftPopup,
    activityList,
  },
  computed: {
    ...mapState(["venderType"]),
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
  },
  data() {
    return {
      activityPopup: false,
      giftPopup: false,
      stepNum: 0,
      backgroundOpacity: false,
      isSave: true,
      valueRow: null,
      //
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
        },
      },
      pickerOptionsValue1: {
        disabledDate: (time) => {
          return time.getTime() > new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      qrcode: null,
      joinBlackList: false,
      checked: false,
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return time.getTime(time) < new Date(this.ruleForm.activityStartTime).getTime();
            } else {
              return time.getTime(time) + day < new Date(this.ruleForm.activityStartTime).getTime();
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return time.getTime() > new Date(this.ruleForm.activityEndTime).getTime() || time.getTime() < Date.now() - 8.64e7;
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })(),
      },
      activityStartTime: null,
      activityEndTime: null,
      timeDay: 0,
      timeOut: 0,

      ruleForm: {
        extraUrlStatus: 2,
        //设置规则表单
        activityName: "",
        activityRulesText: "",
        extraUrl: "",
        isShowJoinNum: 1,
        isShowPost: 1,
      },
      activityList: [
        {
          activityType: 1,
          time: [],
          activityUrl: "",
          name: "",
          brief: "",
          picUrl: "",
          templateId: "",
          activityId: "",
          timeDay1: 0,
          timeOut1: 0,
          subType: "",
        },
      ],
      activeName: "0index",
      tabIndex: 0,
      tabList: [
        {
          name: "活动",
          id: "0index",
        },
      ],
      timeState1: "",
      staute: 0,
    };
  },
  created() {
    // 数据初始化
    if (this.$route.query.valueRow) {
      console.log("query数据==>",this.$route.query);
      this.backgroundOpacity = this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment = this.$route.query.statusComment == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.getEdit();
    } else {
      this.activityTimeChange();
    }
  },
  methods: {
    // 切换活动类型储存输入框的值
    changeRadio(val){
      if(val==1){
        this.activityList[this.tabIndex].url2 = this.activityList[this.tabIndex].activityUrl
        this.activityList[this.tabIndex].name2 = this.activityList[this.tabIndex].name
        this.activityList[this.tabIndex].brief2 = this.activityList[this.tabIndex].brief
        this.activityList[this.tabIndex].time2 = this.activityList[this.tabIndex].time
        this.activityList[this.tabIndex].activityUrl = this.activityList[this.tabIndex].url1 || ""
        this.activityList[this.tabIndex].name = this.activityList[this.tabIndex].name1 || ""
        this.activityList[this.tabIndex].brief = this.activityList[this.tabIndex].brief1 || ""
        this.activityList[this.tabIndex].time = this.activityList[this.tabIndex].time1 || ""
      }else{
        this.activityList[this.tabIndex].name1 = this.activityList[this.tabIndex].name
        this.activityList[this.tabIndex].brief1 = this.activityList[this.tabIndex].brief
        this.activityList[this.tabIndex].time1 = this.activityList[this.tabIndex].time
        this.activityList[this.tabIndex].url1 = this.activityList[this.tabIndex].activityUrl || ""
        this.activityList[this.tabIndex].activityUrl = this.activityList[this.tabIndex].url2 || ""
        this.activityList[this.tabIndex].name = this.activityList[this.tabIndex].name2 || ""
        this.activityList[this.tabIndex].brief = this.activityList[this.tabIndex].brief2 || ""
        this.activityList[this.tabIndex].time = this.activityList[this.tabIndex].time2 || ""
      }
    },
    async getEdit() {
      const { data } = await editSmartPost(this.valueRow);
      this.staute = data.status || 0;
      this.timeState1 = data.startTime;
      this.activityTimeValue = [String(data.startTime), String(data.endTime)];
      this.ruleForm.activityName = data.activityName;
      this.ruleForm.activityStartTime = String(data.startTime);
      this.ruleForm.activityEndTime = String(data.endTime);
      this.ruleForm.extraUrl = data.smartPostActivityRuleDTO.extraUrl;
      this.ruleForm.isShowJoinNum = data.smartPostActivityRuleDTO.isShowJoinNum;
      this.ruleForm.isShowPost = data.smartPostActivityRuleDTO.isShowPost;
      this.activityList = data.smartPostActivityRuleDTO.activityList.map((item) => {
        return {
          ...item,
          time: [item.activityStartTime, item.activityEndTime],
        };
      });
      this.tabList = data.smartPostActivityRuleDTO.activityList.map((item, index) => {
        return {
          name: "活动",
          id: index + "index",
        };
      });
      if(this.$route.query.isCopy == "1"){
        this.valueRow = ""
      }
      this.activityTimeChange();
      this.activityTimeChange1();
    },
    handleClose(val) {
      if (val) {
        console.log(this.tabIndex, this.activityList[this.tabIndex], 66666);
        let EndTime = val.couponEndTime ? new Date(val.couponEndTime).valueOf() : new Date(val.endTime).valueOf();
        let start = new Date(this.ruleForm.activityStartTime).valueOf() || 0;
        if (EndTime < start) return this.$message.warning("请选择活动结束时间大于计划起始时间的活动，避免用户无法参与活动");
        this.activityList[this.tabIndex].activityUrl = val.idUrl;
        // this.activityList[this.tabIndex].url1 = val.idUrl;
        this.activityList[this.tabIndex].activityId = val.id;
        this.activityList[this.tabIndex].subType = val.activityType || val.type;
        this.activityList[this.tabIndex].name = val.activityName;
        let actStart = val.couponStartTime ? val.couponStartTime : val.startTime;
        let actEnd = val.couponEndTime ? val.couponEndTime : val.endTime;
        this.activityList[this.tabIndex].time = [actStart, actEnd];
        this.activityList[this.tabIndex].timeDisable = true;
        this.activityTimeChange1();
        this.timeDisable = true;
      }
      this.activityPopup = false;
    },
    hanleAction() {
      this.activityPopup = true;
    },
    handleImg() {
      this.giftPopup = true;
    },
    handleChoice(val) {
      console.log(val);
      if (val) {
        this.activityList[this.tabIndex].picUrl = val.imageUrl;
        this.activityList[this.tabIndex].templateId = val.id;
      }
      this.giftPopup = false;
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    handleAddTab() {
      if (this.tabList.length == 5) return this.$message.warning("最多添加五个");
      let timestamp = new Date().getTime();
      let obj = {
        name: "活动",
        id: timestamp + "index",
      };
      this.tabList.push(obj);
      let obj1 = {
        activityType: 1,
        time: [],
        activityUrl: "",
        name: "",
        brief: "",
        picUrl: "",
        templateId: "",
        activityId: "",
        subType: "",
      };
      this.activityList.push(obj1);
    },
    handleClickTabs(val) {
      this.tabIndex = val.index;
      this.activityTimeChange1();
    },
    removeTab(targetName) {
      if (this.tabList.length == 1) return this.$message.warning("活动必须添加一个");
      // 删除对应活动填写
      let spliceIndex = -1;
      this.tabList.forEach((val, i) => {
        if (val.id == targetName) spliceIndex = i;
      });

      if (spliceIndex > -1) this.activityList.splice(spliceIndex, 1);
      // 删除 tab
      let tabs = this.tabList;
      let activeName = this.activeName;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.id == targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.id;
            }
          }
        });
      }
      this.activeName = activeName;

      this.tabList = tabs.filter((tab) => tab.id !== targetName);
      this.tabList.forEach((val, i) => {
        if (val.id == activeName) this.tabIndex = i;
      });
    },
    hangdleActivityEdit() {
      let activityUrl = this.activityList[this.tabIndex].activityUrl;
      getActivityInfoFromUrl({ url: activityUrl }).then((res) => {
        if (res.code == 1) {
          this.activityList[this.tabIndex].activityId = res.data.id;
          this.activityList[this.tabIndex].name = res.data.activityName;
          this.activityList[this.tabIndex].subType = res.data.subType;
          this.activityList[this.tabIndex].time = [res.data.startTime, res.data.endTime];
          this.activityTimeChange1();
        }
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime && this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime && this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.valueRow) {
          this.disableTime = true;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    //活动时间驱动
    activityTimeChange1(val) {
      let nowTime = new Date().getTime();
      // debugger;
      let start = new Date(this.activityList[this.tabIndex].time[0]).valueOf();
      let end = new Date(this.activityList[this.tabIndex].time[1]).valueOf();
      let start1 = new Date(this.ruleForm.activityStartTime).valueOf();

      if (end < start1) {
        this.activityList[this.tabIndex].time = [];
        return this.$message.warning("活动结束时间必须大于计划起始时间的活动，避免用户无法参与活动");
      }

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.activityList[this.tabIndex].time[0] && this.activityList[this.tabIndex].time[0].substring(0, 10);
      daysEnd = this.activityList[this.tabIndex].time[1] && this.activityList[this.tabIndex].time[1].substring(0, 10);
      if (this.activityList[this.tabIndex].time[1] && this.activityList[this.tabIndex].time[0]) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        console.log(days, 6666);
        this.activityList[this.tabIndex].timeDay1 = days;
        this.$set(this.activityList, this.tabIndex, this.activityList[this.tabIndex]);
        //计算小时
        date3 = new Date(this.activityList[this.tabIndex].time[1]).getTime() - new Date(this.activityList[this.tabIndex].time[0]).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.activityList[this.tabIndex].timeOut1 = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.activityList[this.tabIndex].timeOut1 = 0;
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      this.ruleForm.activityStartTime = this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue.length == 0 ? "" : this.activityTimeValue[1];
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        smartPostActivityRuleDTO: {
          extraUrl: this.ruleForm.extraUrl,
          extraUrlStatus: 2,
          isShowJoinNum: this.ruleForm.isShowJoinNum,
          isShowPost: this.ruleForm.isShowPost,
          activityList: this.activityList.map((item) => {
            return {
              ...item,
              activityStartTime: item.time.length == 0 ? "" : item.time[0],
              activityEndTime: item.time.length == 0 ? "" : item.time[1],
            };
          }),
        },
      };
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入计划名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入计划时间");
        return;
      }
      let nowTime = new Date().getTime()
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      if(end < nowTime && end){
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      let isflay = false;
      let textFlay = false;
      console.log(this.activityList);
      this.activityList.forEach((item) => {
        if (!item.name || !item.brief || item.time.length == 0 || !item.picUrl || !item.activityUrl) isflay = true;
        if (item.activityUrl.indexOf("http") == -1 || item.activityUrl.indexOf("jd.com") == -1) {
          textFlay = true;
          isflay = true;
        }
      });
      if (isflay) return this.$message.warning(`${textFlay ? "自定义链接必须为京东域内链接" : "请把活动内容填写完整"}`);
      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        if (this.valueRow) {
          if (this.staute == 2) cardParams.startTime = this.timeState1;
          saveSmartPost({ ...cardParams, id: this.valueRow }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              // this.$emit("saveEdit");
              this.$router.go(-1);
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          saveSmartPost(cardParams).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              // this.$emit("saveEdit");
              this.$router.go(-1);
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    clickLocalStep() {
      this.$router.go(-1);
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
.smart {
  display: flex;
  margin-top: 24px;
  &_left {
    width: 260px;
    height: 230px;
    margin-right: 400px;
    // background: #dddddd;
    img {
      width: 100%;
      // height: inherit;
    }
  }
  &_right {
    width: 235px;
    margin-top: -55px;
    // height: 430px;
    &_img {
      height: 430px;
      background: #999;
      display: flex;
      // align-items: center;
      justify-content: center;
      background: url("../../../assets/images/cardManage/zn1.png") no-repeat;
      background-size: 235px 430px;
    }
    &_tip {
      color: #999;
      margin-top: 5px;
      font-size: 12px;
      text-align: center;
    }
  }
  &_content {
    margin-top: 116px;
    overflow: hidden;
    width: 90.1%;
    height: 238px;
    &_title {
      height: 15px;
      margin-top: 3px;
      // padding-left: 2px;
      margin-left: -20px;
      transform: scale(0.8);
    }
    &_js {
      height: 9px;
      font-size: 12px;
      color: #666;

      margin-left: -40px;
      transform: scale(0.64);
    }
    img {
      width: 100%;
      height: 208px;
    }
  }
}
.card-point {
  width: 100%;
  background: #fafafa;
  border-radius: 4px;
  margin-top: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    // margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
    line-height: 1;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.new_group_append {
  /deep/.el-input-group__append {
    background: #7b61ff;
    color: #fff;
  }
}
.actBox {
  width: 125px;
  padding-left: 5px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  display: inline-block;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  margin-right: 5px;
  margin-bottom: 24px;
}
.tips {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 13px 30px;
  background: #fffaee;
  font-size: 13px;
  color: #333;
  img {
    display: inline-block;
    float: left;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 9px 4px 0 3px;
  }
  i {
    color: #fe8f8a;
    opacity: 0.7;
  }
  p {
    margin: 0;
    line-height: 20px;
    padding-left: 18px;
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.add_btn1 {
  cursor: pointer;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.memberTips {
  color: red;
}
.new-tabs-header {
  /deep/.el-tabs__item.is-active {
    border-top: 2px solid #7b61ff !important;
    height: auto;
  }
  // .el-tabs__header {
  //   .el-tabs__nav {
  //     /deep/.is-active {
  //       border-top: 2px solid #7B61FF !important;
  //     }
  //   }
  // }
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
}

.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 860px;
  // height: 217px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
  }
  &_bottom {
    margin-left: 7px;
  }
}

.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #7b61ff;
  }
  color: #999;
}
.delectPosible {
  position: absolute;
  top: -3px;
  right: 6px;
  color: red;
  cursor: pointer;
}
.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}

.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }

  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 40px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url("../../../assets/images/integralCenter/yhq.png");
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #7b61ff;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background: #f2f3f5;
      border-color: #f2f3f5;
      color: #cccccc;
      transition: all 0.2s;
      .el-button--primary{
        background: #f2f3f5;
        border-color: #f2f3f5;
        color: #cccccc;
      }
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>

<style lang="scss">
.createPlayStep {
  .el-step.is-horizontal .el-step__line {
    height: 1px;
  }
  .el-step__head.is-success {
    color: #7b61ff;
    border-color: #7b61ff;
    .el-step__line {
      background-color: #7b61ff;
    }
  }
  .el-step__head.is-process {
    color: #7b61ff;
    border-color: #7b61ff;
  }
  .el-step__title.is-process {
    color: #7b61ff;
  }
  .el-step__title.is-success {
    color: #7b61ff;
  }
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
</style>
